import { createContext } from 'react'

const batchContext = createContext()

export default batchContext
